
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[uid]/[page]",
      function () {
        return require("private-next-pages/category/[uid]/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[uid]/[page]"])
      });
    }
  